import { render, staticRenderFns } from "./userCreate.vue?vue&type=template&id=4dffc248&"
import script from "./userCreate.vue?vue&type=script&lang=js&"
export * from "./userCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports